import { atom, atomFamily } from "recoil";
import { localStorageEffect } from "../utils/store";
import { FilterListStateType } from "../components/filters/models";
import { OnDocumentThreadUpdatedSubscription } from "../containers/financials/documents/messaging/types/queries.generated";

export const pageSizeOptions = [25, 50, 100, 250]; // used in refunds and documents!
type ActivePageType = "refunds.activePage" | "documents.activePage";
type RowsPerPageType = "refunds.rowsPerPage" | "documents.rowsPerPage";

type ActivePage = {
	key: ActivePageType;
	default: number;
};

type RowsPerPage = {
	key: RowsPerPageType;
	default: number;
};

type IncomingMessages = {
	key: "incoming-messages";
	default: Array<OnDocumentThreadUpdatedSubscription["documentThreadUpdated"]>;
};

const initialValueDocumentsActivePage: ActivePage = {
	key: "documents.activePage",
	default: 0,
};

const initialDocumentsRowsPerPage: RowsPerPage = {
	key: "documents.rowsPerPage",
	default: pageSizeOptions[0],
};

const initialIncomingMessages: IncomingMessages = {
	key: "incoming-messages",
	default: [],
};

export const documentsActivePage = atom(initialValueDocumentsActivePage);
export const documentsRowsPerPage = atom(initialDocumentsRowsPerPage);

export const documentPageFilterFamily = atomFamily({
	key: "DocumentPageFilterState",
	default: [],
	effects_UNSTABLE: (param) => [localStorageEffect<FilterListStateType>(param?.toString())],
});

export const incomingMessages = atom(initialIncomingMessages);
